import React from 'react'
import { useParams } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import EmptyPageState from 'components/empty-page-state'
import PartyPopperIcon from 'components/icons/party-popper-icon'
import useDetailStyles from '../../detail-styles'
import ActivityDetailView from '../../components/activity-detail-view'
import useCoachActivityHit from '../../hooks/use-coach-activity-hit'

const SingleActivitiesPage = () => {
  const classes = useDetailStyles()
  const { id } = useParams()
  const { hit, isLoading } = useCoachActivityHit(id)

  if (isLoading) {
    return <Box className={classes.page} />
  }

  if (!hit) {
    return (
      <Box className={classes.page}>
        <Grid item xs={12}>
          <EmptyPageState
            IconComp={() => <PartyPopperIcon />}
            title="No activity found."
            removeButton
          />
        </Grid>
      </Box>
    )
  }

  return (
    <Box className={classes.page}>
      <ActivityDetailView hit={hit} />
    </Box>
  )
}

export default SingleActivitiesPage
